import React, { useEffect, useState } from "react";
import {
    Box,
    Paper,
    Typography,
    TextField,
    MenuItem,
    IconButton,
    Grid,
    Select,
    FormControl,
    Divider,
    CircularProgress
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import ApiService from "../../functions/apiService";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";


const UpdateTemplate = () => {

    const { id } = useParams();
    const navigation = useNavigate();
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [positionDrop, setPositionDrop] = useState([]);
    const [positions, setPositions] = useState([
        { position: "", quantity: 0 }
    ]);
    const [templateName, setTemplateName] = useState("");
    const [description, setDescription] = useState("");
    // const [ovTList, setOvTList] = useState([]);
    const [selectedList, setSelectedList] = useState("");
    const [type, setType] = useState("callback");
    const [list, setList] = useState("");
    const [menu, setMenu] = useState([]);
    useEffect(() => {
        setLoading(true);
        ApiService.get(`/template/show/${id}`)
            .then(({ data }) => {
                const res = data.data;

                setTemplateName(res.Name);
                setDescription(res.Description);
                setSelectedList(res.Ranking_Order);

                const uniqueList = [...new Set(res.positions.map(p => p.List))];
                setList(uniqueList[0] || "");

                setPositions(
                    res.positions.map((p) => ({
                        // position: p?.position_name !== null ?p?.position_name: p?.Position_Id,
                         position: p?.Position_Id,
                        quantity: p.Quantity
                    }))
                );
            })
            .finally(() => setLoading(false));
    }, [id]);

    const getPositionDropown = () => {
        setLoading(true);
        ApiService.get('/positions-list')
            .then(({ data }) => {
                var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: ( cer?.SO_Value) || (cer?.SO_Desc ) } })
                setPositionDrop(certArr)
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
            })
    }

      const loadDDL = () => {
        ApiService.get("/getOvertimeListsDDL").then(({ data }) => {
          setMenu(data);
        });
      };
      useEffect(()=>{
        loadDDL();
      },[])
     const menuArray = Object.entries(menu);


    useEffect(() => {
        getPositionDropown();
    }, []);
    const handleAddPosition = () => {
        setPositions([...positions, { position: "", quantity: 0 }]);
    };

    const handleRemovePosition = (index) => {
        setPositions(positions.filter((_, i) => i !== index));
    };

    const handleChange = (index, field, value) => {
        const updated = [...positions];
        updated[index][field] = value;
        setPositions(updated);
    };
    const goBack = () => {
        navigation(-1);
    }

    const handleSave = async () => {
        const payload = {
            template_id: Number(id),
            name: templateName,
            description: description,
            ranking_order: selectedList,
            type: type,
             list_type:list,
            positions: positions?.filter(p => p.position)?.map((p) => ({
                position_id: p.position,
                quantity: Number(p.quantity),
            })),
        };

        try {
            setSaving(true);
            const res = await ApiService.post("/template/update", payload);
            toast.success(res?.message || "Template updated successfully");
            navigation("/firehouse/template/management");
        } catch (error) {
            toast.error(error?.response?.data?.message || "Update failed");
        } finally {
            setSaving(false);
        }
    };
    if (loading) {
        return (
            <Box
                className="w-100 d-flex justify-content-center align-items-center mt-2"
                style={{ height: '510px' }}
            >
                <CircularProgress />
            </Box>
        );
    }



    return (
        <>
            <Paper sx={{ p: 2, mt: 2 }}>
                <Row>
                    {/* <Col xs={12}> */}
                        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                            <IconButton size="small">
                                 <ArrowBackIosNewIcon fontSize="small" onClick={goBack} style={{color:'#000000'}} />
                            </IconButton>
                            <Typography style={{ fontSize: '28px', fontWeight: '400' }}>
                                Update Template
                            </Typography>
                        </Box>

                        {/* Form Card */}
                        <Paper
                            variant="outlined"
                            sx={{
                                p: 2,
                                borderRadius: 2
                            }}
                            style={{ border: "1px solid #CCCCCC", backgroundColor: '#F5F5F566',marginLeft:"16px",width:"95%" }}
                        >

                            <Col xl={4} md={12} sm={12}>
                                <Typography fontSize={14} fontWeight={500} mb={0.5} style={{ fontFamily: 'karla' }}>
                                    Template Type <span style={{ color: "red" }}>*</span>
                                </Typography>

                                <TextField
                                    fullWidth
                                    select
                                    value={type}
                                    disabled
                                    sx={{
                                        mb: 2,

                                        // Root input styling
                                        '& .MuiOutlinedInput-root': {
                                            height: '48px',
                                            borderRadius: '8px',
                                            fontFamily: 'karla',

                                            '& fieldset': {
                                                borderColor: '#CCCCCC',
                                            },

                                            '&:hover fieldset': {
                                                borderColor: '#B3B3B3',
                                            },
                                            '&.Mui-focused': {
                                                backgroundColor: '#FFFFFF',
                                            },

                                            '&.Mui-focused fieldset': {
                                                borderColor: '#CCCCCC',
                                                borderWidth: '1px',
                                            },
                                        },

                                        // Text inside field
                                        '& .MuiSelect-select': {
                                            height: '48px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            paddingLeft: '14px',
                                            paddingRight: '40px',
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            fontFamily: 'karla',
                                            color: '#000',
                                        },

                                        // Dropdown arrow
                                        '& .MuiSelect-icon': {
                                            right: '12px',
                                            color: '#555',
                                        },

                                        // Disabled but readable (same as image)
                                        '& .Mui-disabled': {
                                            //  backgroundColor: '#FFFFFF',
                                            WebkitTextFillColor: '#000000',
                                        },
                                    }}
                                >
                                    <MenuItem value="callback">Callback</MenuItem>
                                </TextField>
                            </Col>

                            {/* Template Name */}
                            <Typography fontSize={14} fontWeight={500} mb={0.5}>
                                Template Name <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <Col xl={8} md={12} sm={12}>
                                <TextField
                                    fullWidth
                                    placeholder="e.g., Working Fire, Bird Dog - Engine Coverage"
                                    sx={{
                                        mb: 2,

                                        '& .MuiOutlinedInput-root': {
                                            height: '48px',
                                            borderRadius: '8px',
                                            fontFamily: 'karla',
                                              backgroundColor: '#FFFFFF',

                                            '& fieldset': {
                                                borderColor: '#CCCCCC',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#B3B3B3',
                                            },
                                            '&.Mui-focused': {
                                                backgroundColor: '#FFFFFF',
                                            },


                                            '&.Mui-focused fieldset': {
                                                borderColor: '#CCCCCC',
                                                borderWidth: '1px',
                                            },
                                        },

                                        '& input::placeholder': {
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            color: '#9E9E9E',
                                            opacity: 1,
                                        },
                                    }}
                                    value={templateName}
                                    onChange={(e) => setTemplateName(e.target.value)}
                                />

                            </Col>



                            <Typography fontSize={14} fontWeight={500} mb={0.5}>
                                Description
                            </Typography>
                            <Col xl={8} md={12} sm={12}>
                                <TextField
                                    fullWidth
                                    placeholder="Brief explanation of when to use this template"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    sx={{
                                        mb: 2,

                                        '& .MuiOutlinedInput-root': {
                                            height: '48px',
                                            borderRadius: '8px',
                                            fontFamily: 'karla',
                                            backgroundColor: '#FFFFFF',

                                            '& fieldset': {
                                                borderColor: '#CCCCCC',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#B3B3B3',
                                            },


                                            '&.Mui-focused fieldset': {
                                                borderColor: '#CCCCCC',
                                                borderWidth: '1px',
                                            },
                                            '&.Mui-focused': {
                                                backgroundColor: '#FFFFFF',
                                            },

                                        },

                                        '& input::placeholder': {
                                            fontSize: '16px',
                                            fontWeight: 500,
                                            color: '#9E9E9E',
                                            opacity: 1,
                                        },
                                    }}
                                />
                            </Col>

                            <Grid container spacing={2} alignItems="center" marginBottom={1}>

                                {/* List dropdown */}
                                <Grid item xs={12} md={8}>
                                    <Typography fontSize={14} fontWeight={500} mb={0.5}>
                                        Ranking Method 
                                    </Typography>

                                    <FormControl fullWidth size="small">
                                        <Select
                                            value={selectedList ?? ""}
                                            // style={{ height: '48px', }}
                                            onChange={(e) => setSelectedList(e.target.value)}
                                        renderValue={(selected) =>
                                            !selected ? <span style={{ color: "#9CA3AF" }}>Selected ranking</span> : selected
                                        }
                                            displayEmpty
                                            sx={{
                                                height: '48px',
                                                borderRadius: '8px',
                                                fontFamily: 'karla',
                                                backgroundColor: '#FFFFFF',
                                                fontSize: '16px',

                                                // Outline border
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#CCCCCC',
                                                },

                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#CCCCCC',
                                                },

                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#CCCCCC',
                                                    borderWidth: '1px',
                                                },
                                                '&.Mui-focused': {
                                                backgroundColor: '#FFFFFF',
                                            },

                                                // Selected text
                                                '& .MuiSelect-select': {
                                                    padding: '12px 40px 12px 14px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                },

                                                // Dropdown arrow
                                                '& .MuiSelect-icon': {
                                                    right: '12px',
                                                    color: '#555',
                                                },
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                Select list
                                            </MenuItem>

                                            <MenuItem value="By Overtime Hours">
                                                By Overtime Hours
                                            </MenuItem>
                                            <MenuItem value="By Seniority">
                                                By Seniority
                                            </MenuItem>
                                            <MenuItem value="First Come First Served">
                                                First Come First Served
                                            </MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>



                            <Col lg={8} md={12} sm={12}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 2
                                    }}
                                >
                                    <Typography fontSize={14} fontWeight={600}>
                                        Position Requirements <span style={{ color: "red" }}>*</span>
                                    </Typography>
                                    {/* <ButtonTheme type='submit' variant="filled" color='primary' className='px-2 mx-2' onClick={handleAddPosition} >
                                        + Add Position
                                    </ButtonTheme> */}
                                </Box>
                            </Col>
                        <Grid container spacing={2} alignItems="center" marginBottom={1}>
                            <Grid item xs={12} md={8}>
                                <Typography fontSize={16} fontWeight={500} mb={0.5}>
                                    List
                                </Typography>

                                <FormControl fullWidth size="small">
                                    <Select
                                        value={list}
                                        // style={{ height: '48px', }}
                                        placeholder=""
                                        onChange={(e) => setList(e.target.value)}
                                        displayEmpty
                                        sx={{
                                            height: '48px',
                                            borderRadius: '8px',
                                            fontFamily: 'karla',
                                            backgroundColor: '#FFFFFF',
                                            fontSize: '16px',

                                            // Outline border
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#CCCCCC',
                                            },
                                            '&.Mui-focused': {
                                                backgroundColor: '#FFFFFF',
                                            },

                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#CCCCCC',
                                            },

                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#CCCCCC',
                                                borderWidth: '1px',
                                            },

                                            // Selected text
                                            '& .MuiSelect-select': {
                                                padding: '12px 40px 12px 14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                            },

                                            // Dropdown arrow
                                            '& .MuiSelect-icon': {
                                                right: '12px',
                                                color: '#555',
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                            Select List
                                        </MenuItem>

                                        {menuArray.map(([key, value]) => (
                                            <MenuItem value={key} key={key}>
                                                {value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                            {positions.map((row, index) => (
                                <Grid container spacing={2} alignItems="flex-end" mb={2} key={index}>

                                    {/* Position dropdown */}
                                    <Grid item xs={12} md={6}>
                                        <Typography fontSize={13} mb={0.5}>
                                            Position <span style={{ color: "red" }}>*</span>
                                        </Typography>

                                        <FormControl fullWidth size="small">
                                            <Select
                                                value={row.position}
                                                onChange={(e) =>
                                                    handleChange(index, "position", e.target.value)
                                                }
                                                displayEmpty
                                                sx={{
                                                    height: '48px',
                                                    borderRadius: '8px',
                                                    fontFamily: 'karla',
                                                    backgroundColor: '#FFFFFF',
                                                    fontSize: '16px',

                                                    // Outline border
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#CCCCCC',
                                                    },

                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#CCCCCC',
                                                    },

                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#CCCCCC',
                                                        borderWidth: '1px',
                                                    },
                                                    '&.Mui-focused': {
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                    // Selected text
                                                    '& .MuiSelect-select': {
                                                        padding: '12px 40px 12px 14px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    },

                                                    // Dropdown arrow
                                                    '& .MuiSelect-icon': {
                                                        right: '12px',
                                                        color: '#555',
                                                    },
                                                }}
                                            >
                                                <MenuItem value="">
                                                    Select position
                                                </MenuItem>

                                                {positionDrop.map((opt) => (
                                                    <MenuItem key={opt.value} value={opt.value}>
                                                        {opt.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    {/* Quantity */}
                                    <Grid item xs={12} md={1}>
                                        <Typography fontSize={13} mb={0.5}>
                                            Quantity
                                        </Typography>
                                        <TextField
                                            size="small"
                                            type="number"
                                            inputProps={{
                                                min: 0,
                                                step: 1,
                                            }}
                                            fullWidth
                                            value={row?.position ? row.quantity : 0}
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    height: '48px',
                                                    borderRadius: '8px',
                                                    fontFamily: 'karla',
                                                     backgroundColor: '#FFFFFF',
                                                    '&.Mui-focused': {
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                    '& fieldset': { borderColor: '#CCCCCC' },
                                                    '&:hover fieldset': { borderColor: '#CCCCCC' },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#CCCCCC',
                                                        borderWidth: '1px',
                                                    },
                                                },
                                                '& input': {
                                                    textAlign: 'center',
                                                    fontSize: '16px',
                                                    fontWeight: 500,
                                                    padding: '0',
                                                },
                                            }}
                                            onFocus={(e) => {
                                                // select whole value so typing replaces 0
                                                e.target.select();
                                            }}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                if (value === "") {
                                                    handleChange(index, "quantity", "");
                                                    return;
                                                }

                                                handleChange(index, "quantity", Number(value));
                                            }}
                                            onBlur={() => {
                                                // normalize on blur
                                                if (row.quantity === "" || isNaN(row.quantity)) {
                                                    handleChange(index, "quantity", 0);
                                                }
                                            }}
                                        />
                                    </Grid>

                                    {/* Remove button */}
                                    <Grid item xs={12} md={1}>
                                        {positions.length > 1 && (
                                            <Button
                                                variant="outlined"
                                                onClick={() => handleRemovePosition(index)}
                                                disabled={index === 0}
                                                sx={{
                                                    height: "48px",
                                                    minWidth: "100%",
                                                    border: "1px solid #DF2F40",
                                                    color: index === 0 ? "#BDBDBD" : "#DF2F40",
                                                    borderRadius: "0px",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    textTransform: "none",
                                                    fontFamily: "karla",

                                                    "&:hover": {
                                                        border: index === 0 ? "1px solid #BDBDBD" : "1px solid #DF2F40",
                                                        backgroundColor:
                                                            index === 0 ? "transparent" : "rgba(255, 59, 48, 0.04)",
                                                    },
                                                }} 
                                               
                                            >
                                                Remove
                                            </Button>
                                        )}
                                    </Grid>

                                </Grid>
                            ))}
                        <Col lg={8} md={12} sm={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 2
                                }}
                            >
                                {/* <Typography fontSize={18} fontWeight={700}>
                                                                Position Requirements <span style={{ color: "red" }}>*</span>
                                                            </Typography> */}
                                <ButtonTheme type='submit' variant="filled" color='primary' className='px-2 mx-2' onClick={handleAddPosition} >
                                    + Add Position
                                </ButtonTheme>
                            </Box>
                        </Col>
                        </Paper>


                        <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }} className='pt-5 px-2' style={{ marginLeft: "8px" }}>
                            <ButtonTheme disabled={saving} onClick={goBack} variant="filled" className='px-5'>
                                Cancel
                            </ButtonTheme>
                            <ButtonTheme disabled={saving} type='submit' variant="filled" color='primary' className='px-5 mx-2' onClick={handleSave} >
                                {saving && 'Loading...'}
                                {!saving && 'Update'}
                            </ButtonTheme>

                        </Grid>
                    {/* </Col> */}

                </Row>


            </Paper>
        </>

    );
};

export default UpdateTemplate;
